import { Tooltip } from "@mui/material"

export const BoxTasks = ({ items, handleDoneChange, handleDeleteTaks, handleEditTaks, idOpor }) => {
    return (
        <div className='mt-3'>
            {items.map(it => (
                <div className="flex items-center">
                    <div>
                        <Tooltip title={it?.nombre_clasificacion || 'Sin clasificación'}>
                            <i className={`${it?.clasificacion_icon_name || 'bi bi-check2-circle'} text-[20px] me-1`}></i>
                        </Tooltip>
                    </div>
                    <div
                        key={it.id}
                        className='text-[16px] bg-white m-2 p-2 flex flex-column justify-start items-start relative w-full rounded'
                    >
                        <span>
                            {it.edit &&
                                <input
                                    type="checkbox"
                                    className='w-5 h-4 cursor-pointer ms-2'
                                    checked={it.done}
                                    onChange={(e) => handleDoneChange(e, it.id)}
                                />
                            }
                            <span className='ms-2'>{it.nombre}</span>
                        </span>

                        {(it.nota_larga !== '' && it.nota_larga !== null) &&
                            <div className="mt-2 bg-[#f9f3fa] p-2 rounded-lg w-fit">
                                <span className="font-extrabold">Nota:</span>
                                <p className="text-[15px] text-gray-600">{it.nota_larga}</p>
                            </div>
                        }

                        <span className='text-[12px] text-gray-600 mt-2'>
                            {it.vencida &&
                                <span className='text-[red] me-2 font-bold'>VENCIDA</span>
                            }
                            <span className="me-1">{it.fecha}</span>
                            {it.hora && <span className="me-1">a las {it.hora}</span>}
                            -
                            <span className="ms-1">{it.responsable}</span>
                        </span>

                        {/* <button
                            className="absolute right-9 bottom-1 text-gray-400"
                            onClick={() => handleEditTaks(idOpor, it.id)}
                        >
                            <i class="bi bi-pencil text-[14px]"></i>
                        </button> */}

                        <button
                            className="absolute right-2 bottom-1 text-gray-400"
                            onClick={() => handleDeleteTaks(idOpor, it.id)}
                        >
                            <i className="bi bi-trash"></i>
                        </button>

                    </div>
                </div>

            ))}
        </div>
    )
}